// This file is AUTOGENERATED, do not edit it manually!!!

import { customFields as customFieldsde } from './customFieldsResx.de';
import { customFields as customFieldsen } from './customFieldsResx.en';
import { customFields as customFieldsen_risk } from './customFieldsResx.en_risk';
import { customFields as customFieldses } from './customFieldsResx.es';
import { customFields as customFieldsfr } from './customFieldsResx.fr';
import { customFields as customFieldsit } from './customFieldsResx.it';
import { customFields as customFieldsnl } from './customFieldsResx.nl';
import { customFields as customFieldspl } from './customFieldsResx.pl';
import { customFields as customFieldspt } from './customFieldsResx.pt';
import { customFields as customFieldsru } from './customFieldsResx.ru';
import { customFields as customFieldssk } from './customFieldsResx.sk';
import { customFields as customFieldssv } from './customFieldsResx.sv';
import { customFields as customFieldstr } from './customFieldsResx.tr';

const langMap: { [k: string]: Partial<typeof customFieldsen> } = {
    de: customFieldsde,
    en: customFieldsen,
    en_risk: customFieldsen_risk,
    es: customFieldses,
    fr: customFieldsfr,
    it: customFieldsit,
    nl: customFieldsnl,
    pl: customFieldspl,
    pt: customFieldspt,
    ru: customFieldsru,
    sk: customFieldssk,
    sv: customFieldssv,
    tr: customFieldstr,
};

/* tslint:disable: max-line-length */
export const customFieldsResx = {
    get add_own_options() {
        return langMap[ep.resxCulture].add_own_options || langMap.en.add_own_options;
    },
    get allActivities() {
        return langMap[ep.resxCulture].allActivities || langMap.en.allActivities;
    },
    get AllActivities_group_title() {
        return langMap[ep.resxCulture].AllActivities_group_title || langMap.en.AllActivities_group_title;
    },
    get batch_mark_as_optional() {
        return langMap[ep.resxCulture].batch_mark_as_optional || langMap.en.batch_mark_as_optional;
    },
    get batch_mark_as_required() {
        return langMap[ep.resxCulture].batch_mark_as_required || langMap.en.batch_mark_as_required;
    },
    get boolean_field_type() {
        return langMap[ep.resxCulture].boolean_field_type || langMap.en.boolean_field_type;
    },
    get create_cf() {
        return langMap[ep.resxCulture].create_cf || langMap.en.create_cf;
    },
    get custom_field_could_not_be_deleted() {
        return langMap[ep.resxCulture].custom_field_could_not_be_deleted || langMap.en.custom_field_could_not_be_deleted;
    },
    get custom_field_could_not_be_removed() {
        return langMap[ep.resxCulture].custom_field_could_not_be_removed || langMap.en.custom_field_could_not_be_removed;
    },
    get custom_field_readonly_warning() {
        return langMap[ep.resxCulture].custom_field_readonly_warning || langMap.en.custom_field_readonly_warning;
    },
    get customer() {
        return langMap[ep.resxCulture].customer || langMap.en.customer;
    },
    get Customer_group_title() {
        return langMap[ep.resxCulture].Customer_group_title || langMap.en.Customer_group_title;
    },
    get default_field_name() {
        return langMap[ep.resxCulture].default_field_name || langMap.en.default_field_name;
    },
    get delete_field_title() {
        return langMap[ep.resxCulture].delete_field_title || langMap.en.delete_field_title;
    },
    get everywhere() {
        return langMap[ep.resxCulture].everywhere || langMap.en.everywhere;
    },
    get expense() {
        return langMap[ep.resxCulture].expense || langMap.en.expense;
    },
    get Expense_group_title() {
        return langMap[ep.resxCulture].Expense_group_title || langMap.en.Expense_group_title;
    },
    get field_is_used_in_formula() {
        return langMap[ep.resxCulture].field_is_used_in_formula || langMap.en.field_is_used_in_formula;
    },
    get field_non_editable_portfolio_restriction() {
        return langMap[ep.resxCulture].field_non_editable_portfolio_restriction || langMap.en.field_non_editable_portfolio_restriction;
    },
    get field_non_editable_without_portfolio_restriction() {
        return langMap[ep.resxCulture].field_non_editable_without_portfolio_restriction || langMap.en.field_non_editable_without_portfolio_restriction;
    },
    get field_non_editable_wrong_space() {
        return langMap[ep.resxCulture].field_non_editable_wrong_space || langMap.en.field_non_editable_wrong_space;
    },
    get fields_plural() {
        return langMap[ep.resxCulture].fields_plural || langMap.en.fields_plural;
    },
    get formula_description() {
        return langMap[ep.resxCulture].formula_description || langMap.en.formula_description;
    },
    get formula_example() {
        return langMap[ep.resxCulture].formula_example || langMap.en.formula_example;
    },
    get formula_field_type() {
        return langMap[ep.resxCulture].formula_field_type || langMap.en.formula_field_type;
    },
    get formula_function_description() {
        return langMap[ep.resxCulture].formula_function_description || langMap.en.formula_function_description;
    },
    get hyperlink_field_type() {
        return langMap[ep.resxCulture].hyperlink_field_type || langMap.en.hyperlink_field_type;
    },
    get issue() {
        return langMap[ep.resxCulture].issue || langMap.en.issue;
    },
    get Issue_group_title() {
        return langMap[ep.resxCulture].Issue_group_title || langMap.en.Issue_group_title;
    },
    get limitReachedMessage() {
        return langMap[ep.resxCulture].limitReachedMessage || langMap.en.limitReachedMessage;
    },
    get mark_as_optional_feedback() {
        return langMap[ep.resxCulture].mark_as_optional_feedback || langMap.en.mark_as_optional_feedback;
    },
    get mark_as_optional_feedback_failure() {
        return langMap[ep.resxCulture].mark_as_optional_feedback_failure || langMap.en.mark_as_optional_feedback_failure;
    },
    get mark_as_required_feedback() {
        return langMap[ep.resxCulture].mark_as_required_feedback || langMap.en.mark_as_required_feedback;
    },
    get mark_as_required_feedback_failure() {
        return langMap[ep.resxCulture].mark_as_required_feedback_failure || langMap.en.mark_as_required_feedback_failure;
    },
    get msg_deleteUsedValue() {
        return langMap[ep.resxCulture].msg_deleteUsedValue || langMap.en.msg_deleteUsedValue;
    },
    get msg_entities_portfolioRemoved() {
        return langMap[ep.resxCulture].msg_entities_portfolioRemoved || langMap.en.msg_entities_portfolioRemoved;
    },
    get msg_entities_spaceRemoved() {
        return langMap[ep.resxCulture].msg_entities_spaceRemoved || langMap.en.msg_entities_spaceRemoved;
    },
    get msg_lead_to() {
        return langMap[ep.resxCulture].msg_lead_to || langMap.en.msg_lead_to;
    },
    get msg_restrictionsAdded() {
        return langMap[ep.resxCulture].msg_restrictionsAdded || langMap.en.msg_restrictionsAdded;
    },
    get msg_restrictionsRemoved() {
        return langMap[ep.resxCulture].msg_restrictionsRemoved || langMap.en.msg_restrictionsRemoved;
    },
    get msg_unportfolioedOff() {
        return langMap[ep.resxCulture].msg_unportfolioedOff || langMap.en.msg_unportfolioedOff;
    },
    get msg_valueRemoved() {
        return langMap[ep.resxCulture].msg_valueRemoved || langMap.en.msg_valueRemoved;
    },
    get no_portfolio() {
        return langMap[ep.resxCulture].no_portfolio || langMap.en.no_portfolio;
    },
    get nowhere() {
        return langMap[ep.resxCulture].nowhere || langMap.en.nowhere;
    },
    get numeric_field_type() {
        return langMap[ep.resxCulture].numeric_field_type || langMap.en.numeric_field_type;
    },
    get other_portfolios() {
        return langMap[ep.resxCulture].other_portfolios || langMap.en.other_portfolios;
    },
    get portfolio() {
        return langMap[ep.resxCulture].portfolio || langMap.en.portfolio;
    },
    get Portfolio_group_title() {
        return langMap[ep.resxCulture].Portfolio_group_title || langMap.en.Portfolio_group_title;
    },
    get project() {
        return langMap[ep.resxCulture].project || langMap.en.project;
    },
    get Project_group_title() {
        return langMap[ep.resxCulture].Project_group_title || langMap.en.Project_group_title;
    },
    get readonly_warning_no_access_to_portfolios() {
        return langMap[ep.resxCulture].readonly_warning_no_access_to_portfolios || langMap.en.readonly_warning_no_access_to_portfolios;
    },
    get remove_field_description() {
        return langMap[ep.resxCulture].remove_field_description || langMap.en.remove_field_description;
    },
    get remove_field_title() {
        return langMap[ep.resxCulture].remove_field_title || langMap.en.remove_field_title;
    },
    get request() {
        return langMap[ep.resxCulture].request || langMap.en.request;
    },
    get Request_group_title() {
        return langMap[ep.resxCulture].Request_group_title || langMap.en.Request_group_title;
    },
    get required_fileds_not_filled() {
        return langMap[ep.resxCulture].required_fileds_not_filled || langMap.en.required_fileds_not_filled;
    },
    get select_from() {
        return langMap[ep.resxCulture].select_from || langMap.en.select_from;
    },
    get spaces_field_label() {
        return langMap[ep.resxCulture].spaces_field_label || langMap.en.spaces_field_label;
    },
    get spaces_field_section_title() {
        return langMap[ep.resxCulture].spaces_field_section_title || langMap.en.spaces_field_section_title;
    },
    get task() {
        return langMap[ep.resxCulture].task || langMap.en.task;
    },
    get Task_group_title() {
        return langMap[ep.resxCulture].Task_group_title || langMap.en.Task_group_title;
    },
    get text_add() {
        return langMap[ep.resxCulture].text_add || langMap.en.text_add;
    },
    get text_add_new_item() {
        return langMap[ep.resxCulture].text_add_new_item || langMap.en.text_add_new_item;
    },
    get text_add_portfolio() {
        return langMap[ep.resxCulture].text_add_portfolio || langMap.en.text_add_portfolio;
    },
    get text_addDescription() {
        return langMap[ep.resxCulture].text_addDescription || langMap.en.text_addDescription;
    },
    get text_all_objects() {
        return langMap[ep.resxCulture].text_all_objects || langMap.en.text_all_objects;
    },
    get text_available_in() {
        return langMap[ep.resxCulture].text_available_in || langMap.en.text_available_in;
    },
    get text_create_new_field() {
        return langMap[ep.resxCulture].text_create_new_field || langMap.en.text_create_new_field;
    },
    get text_currentIdentity() {
        return langMap[ep.resxCulture].text_currentIdentity || langMap.en.text_currentIdentity;
    },
    get text_custom_field_for() {
        return langMap[ep.resxCulture].text_custom_field_for || langMap.en.text_custom_field_for;
    },
    get text_delete() {
        return langMap[ep.resxCulture].text_delete || langMap.en.text_delete;
    },
    get text_delete_permanently() {
        return langMap[ep.resxCulture].text_delete_permanently || langMap.en.text_delete_permanently;
    },
    get text_deleteValue() {
        return langMap[ep.resxCulture].text_deleteValue || langMap.en.text_deleteValue;
    },
    get text_edit() {
        return langMap[ep.resxCulture].text_edit || langMap.en.text_edit;
    },
    get text_empty_page_part1() {
        return langMap[ep.resxCulture].text_empty_page_part1 || langMap.en.text_empty_page_part1;
    },
    get text_empty_page_part2() {
        return langMap[ep.resxCulture].text_empty_page_part2 || langMap.en.text_empty_page_part2;
    },
    get text_error_title() {
        return langMap[ep.resxCulture].text_error_title || langMap.en.text_error_title;
    },
    get text_field_type() {
        return langMap[ep.resxCulture].text_field_type || langMap.en.text_field_type;
    },
    get text_fieldName() {
        return langMap[ep.resxCulture].text_fieldName || langMap.en.text_fieldName;
    },
    get text_fieldType() {
        return langMap[ep.resxCulture].text_fieldType || langMap.en.text_fieldType;
    },
    get text_filter() {
        return langMap[ep.resxCulture].text_filter || langMap.en.text_filter;
    },
    get text_include_in_unportfolioed_projects() {
        return langMap[ep.resxCulture].text_include_in_unportfolioed_projects || langMap.en.text_include_in_unportfolioed_projects;
    },
    get text_isIdentity() {
        return langMap[ep.resxCulture].text_isIdentity || langMap.en.text_isIdentity;
    },
    get text_isNumeric() {
        return langMap[ep.resxCulture].text_isNumeric || langMap.en.text_isNumeric;
    },
    get text_isRequired() {
        return langMap[ep.resxCulture].text_isRequired || langMap.en.text_isRequired;
    },
    get text_place_plural() {
        return langMap[ep.resxCulture].text_place_plural || langMap.en.text_place_plural;
    },
    get text_remainingValuesTemplate() {
        return langMap[ep.resxCulture].text_remainingValuesTemplate || langMap.en.text_remainingValuesTemplate;
    },
    get text_remove() {
        return langMap[ep.resxCulture].text_remove || langMap.en.text_remove;
    },
    get text_restricted_by_portfolio() {
        return langMap[ep.resxCulture].text_restricted_by_portfolio || langMap.en.text_restricted_by_portfolio;
    },
    get text_set_restrictions() {
        return langMap[ep.resxCulture].text_set_restrictions || langMap.en.text_set_restrictions;
    },
    get textarearich_field_type() {
        return langMap[ep.resxCulture].textarearich_field_type || langMap.en.textarearich_field_type;
    },
    get timeEntry() {
        return langMap[ep.resxCulture].timeEntry || langMap.en.timeEntry;
    },
    get TimeEntry_group_title() {
        return langMap[ep.resxCulture].TimeEntry_group_title || langMap.en.TimeEntry_group_title;
    },
    get tooltip_disable_batch() {
        return langMap[ep.resxCulture].tooltip_disable_batch || langMap.en.tooltip_disable_batch;
    },
    get tooltip_everywhere() {
        return langMap[ep.resxCulture].tooltip_everywhere || langMap.en.tooltip_everywhere;
    },
    get tooltip_nowhere() {
        return langMap[ep.resxCulture].tooltip_nowhere || langMap.en.tooltip_nowhere;
    },
    get tooltip_other_portfolios() {
        return langMap[ep.resxCulture].tooltip_other_portfolios || langMap.en.tooltip_other_portfolios;
    },
    get tooltip_portfolio_and_without_part1() {
        return langMap[ep.resxCulture].tooltip_portfolio_and_without_part1 || langMap.en.tooltip_portfolio_and_without_part1;
    },
    get tooltip_portfolio_and_without_part2() {
        return langMap[ep.resxCulture].tooltip_portfolio_and_without_part2 || langMap.en.tooltip_portfolio_and_without_part2;
    },
    get tooltip_portfolio_name() {
        return langMap[ep.resxCulture].tooltip_portfolio_name || langMap.en.tooltip_portfolio_name;
    },
    get tooltip_without_portfolio() {
        return langMap[ep.resxCulture].tooltip_without_portfolio || langMap.en.tooltip_without_portfolio;
    },
    get unknown_portfolio_description() {
        return langMap[ep.resxCulture].unknown_portfolio_description || langMap.en.unknown_portfolio_description;
    },
    get upgradeToEnterpriseMessage() {
        return langMap[ep.resxCulture].upgradeToEnterpriseMessage || langMap.en.upgradeToEnterpriseMessage;
    },
    get use_cfs_options() {
        return langMap[ep.resxCulture].use_cfs_options || langMap.en.use_cfs_options;
    },
    get use_own_options() {
        return langMap[ep.resxCulture].use_own_options || langMap.en.use_own_options;
    },
    get user() {
        return langMap[ep.resxCulture].user || langMap.en.user;
    },
    get User_group_title() {
        return langMap[ep.resxCulture].User_group_title || langMap.en.User_group_title;
    },
    get validation_error_InvalidBracketsNumber() {
        return langMap[ep.resxCulture].validation_error_InvalidBracketsNumber || langMap.en.validation_error_InvalidBracketsNumber;
    },
    get validation_error_InvalidField() {
        return langMap[ep.resxCulture].validation_error_InvalidField || langMap.en.validation_error_InvalidField;
    },
    get validation_error_InvalidOperation() {
        return langMap[ep.resxCulture].validation_error_InvalidOperation || langMap.en.validation_error_InvalidOperation;
    },
    get validation_error_InvalidSymbol() {
        return langMap[ep.resxCulture].validation_error_InvalidSymbol || langMap.en.validation_error_InvalidSymbol;
    },
    get validation_error_MismatchedArgumentType() {
        return langMap[ep.resxCulture].validation_error_MismatchedArgumentType || langMap.en.validation_error_MismatchedArgumentType;
    },
    get validation_error_MismatchedInput() {
        return langMap[ep.resxCulture].validation_error_MismatchedInput || langMap.en.validation_error_MismatchedInput;
    },
    get validation_error_MismatchedOperandType() {
        return langMap[ep.resxCulture].validation_error_MismatchedOperandType || langMap.en.validation_error_MismatchedOperandType;
    },
    get validation_error_MismatchedReturnType() {
        return langMap[ep.resxCulture].validation_error_MismatchedReturnType || langMap.en.validation_error_MismatchedReturnType;
    },
    get validation_error_Unknown() {
        return langMap[ep.resxCulture].validation_error_Unknown || langMap.en.validation_error_Unknown;
    },
    get visibility_title() {
        return langMap[ep.resxCulture].visibility_title || langMap.en.visibility_title;
    },
    get warning_linked_global_field_activities() {
        return langMap[ep.resxCulture].warning_linked_global_field_activities || langMap.en.warning_linked_global_field_activities;
    },
    get warning_linked_global_field_expenses() {
        return langMap[ep.resxCulture].warning_linked_global_field_expenses || langMap.en.warning_linked_global_field_expenses;
    },
    get warning_linked_global_field_projects() {
        return langMap[ep.resxCulture].warning_linked_global_field_projects || langMap.en.warning_linked_global_field_projects;
    },
    get warning_linked_global_field_time() {
        return langMap[ep.resxCulture].warning_linked_global_field_time || langMap.en.warning_linked_global_field_time;
    },
    get warning_wont_visible_without_space() {
        return langMap[ep.resxCulture].warning_wont_visible_without_space || langMap.en.warning_wont_visible_without_space;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.customFields = customFieldsResx;
